<template>
  <div>
    <strong v-if="minReward || maxReward" :class="cssClass">
      <currency :val="getSeventeenPercent(minReward)" v-if="minReward" :currency="currency" />
      <span v-if="minReward && maxReward">-</span>
      <currency :val="getSeventeenPercent(maxReward)"  :currency="currency"/>
    </strong>
    <strong v-else-if="jobSource === 'jp'" :class="cssClass">{{getFiatRewardDonation}} USD</strong>
    <strong v-else :class="cssClass">{{getRewardPercentage}}{{this.$t('widget.percentOfSalary')}}</strong>
    <span class="subtitle is-7">{{this.$t('widget.freeDonation')}}</span>
  </div>
</template>

<script>
import Currency from '@/components/general/currency'
import RewardHelper from '@/helpers/reward'
import GlobalData from '@/helpers/global-data'

export default {
  components: {
    Currency
  },
  props: {
    min: {
      type: [Number],
      default: null
    },
    max: {
      type: [Number],
      default: null
    },
    rewardPercentage: {
      type: [Number],
      default: null
    },
    minReward: {
      type: [Number],
      default: null
    },
    maxReward: {
      type: [Number],
      default: null
    },
    cssClass: {
      type: String,
      default: 'strong'
    },
    currency: {
      type: String,
      default: 'USD'
    },
    referrer: {
      type: Boolean,
      default: false
    },
    fiatReward: {
      type: [Number],
      default: 0
    },
    jobSource: {
      type: String,
      default: 'HV'
    }
  },
  computed: {
    charityPercentage () {
      return RewardHelper.share.charity
    },
    getFiatRewardDonation () {
      return this.fiatReward && this.getSeventeenPercent(this.fiatReward).toFixed(2)
    },
    getRewardPercentage () {
      return this.rewardPercentage && this.getSeventeenPercent(this.rewardPercentage).toFixed(2)
    }
  },
  methods: {
    getSeventeenPercent (reward) {
      let donation = (parseFloat(reward) / 100)
      return donation * 17
    },
    userRewardPercentage () {
      const f = this.referrer ? GlobalData.referralFraction() : 1
      const other = (this.rewardPercentage / 2)
      return (this.rewardPercentage - other) * f
    }
  }
}
</script>
<style lang="scss" scoped>
  .strong {
    font-size: 0.75rem;
    margin-bottom: 0.25rem;
  }
  strong {
    display: block;
  }
  .title {
    margin-bottom: 0.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/charity.vue